import { t } from 'i18next'

import { TBeforePlanSubscriptionBProps, TStyledIsBold } from './types'

export const BeforePlanSubscriptionC = ({
  selectedPlan,
  isBold,
}: TBeforePlanSubscriptionBProps & TStyledIsBold) => {
  let className = 'before-plan-subscription'
  if (isBold) {
    className += ' bold'
  }

  const renewEvery = selectedPlan.renewEvery
  const renewAfter = selectedPlan.renewAfter
  const price = selectedPlan.price

  const trialDisclaimer =
    t('selectPlanScreen.disclaimer.trial') ||
    'We’ve automatically applied the discount to your {renewAfter} trial price. Please note that your subscription will be automatically renewed at the full price of ${price} at the end of your trial and will then be continuously every {renewEvery}.'
  const discountDisclaimer =
    t('selectPlanScreen.disclaimer.discount') ||
    'We’ve automatically applied the discount to your first subscription price. Please note that your subscription will be automatically renewed at the full price of ${price} at the end of chosen subscription term. '

  let disclaimer =
    selectedPlan.trialDuration === selectedPlan.duration ? discountDisclaimer : trialDisclaimer

  disclaimer = disclaimer
    .replace('{renewAfter}', renewAfter)
    .replace('{price}', price.toString())
    .replace('{renewEvery}', renewEvery)

  return <div className={className}>{disclaimer}</div>
}
